import { Box, Card, CardContent, Typography, Grid, Autocomplete, TextField, Button, Checkbox, Switch } from "@mui/material";
import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import Snack from "components/Snack";
import Skeleton from "./skeleton"; 
import _ from "lodash";
import {getLocations} from '../utils';
import { updateCrozierAccess } from "redux/actions/addEditWorker";
import { getCrozierRoles, getWorkerRole } from 'services'

const Crozier = ({handleChange}) => {
      const location = useLocation();
      const dispatch = useDispatch();
      const workerData = location.state && location.state.worker ? location.state.worker : null;
      const empId = location.state && location.state.empId ? location.state.empId : '';
      const approveForMgr = location.state && location.state.approveForManager
                                ? location.state.approveForManager : {};
      const user = useSelector((state) => state.user.auth.user);  
      const crozierData = useSelector(state => state.addEditWorker.workerRoles.crozier || {});
      const loadingRoles = useSelector(state => state.addEditWorker.loadingRoles);
      const imtRole = useSelector((state) => state.user.imtRole || null);
      const [formValues, setFormValues] = useState({});
      const [formErrors, setFormErrors] = useState({});
      const [snackControl, setSnackControl] = useState({ open: false, message: "", severity: 'success' });
      const [disableSave, setDisableSave] = useState(true);
      const [districtOptions, setDistrictOptions] = useState([]);
      const [buildingOptions, setBuildingOptions] = useState([]);
      const [readOnly, setReadOnly] = useState(true);
      const [roles, setRoles] = useState([]);
      const [selectedRole, setSelectedRole] = useState(null);
      const [selectedCapabilities, setSelectedCapabilities] = useState([]);
      const [enableRoleEdit, setEnableRoleEdit] = useState(false);
      const [loadingOptions, setLoadingOptions] = useState(true);

      useEffect(() => {
        if (!user?.workerId) return;

        const fetchRoles = async () => {
          try {
            const [rolesResponse, loggedInWorkerCrozierRole] =
              await Promise.all([
                getCrozierRoles(),
                getWorkerRole(user.workerId, "crozier"),
              ]);

            if (
              loggedInWorkerCrozierRole && loggedInWorkerCrozierRole.role &&
              rolesResponse?.length
            ) {
              const currentRole = rolesResponse.find(
                role => role.id === loggedInWorkerCrozierRole.role
              );
              setEnableRoleEdit(currentRole?.canProvideAccess || false);
              console.log("Fetched roles", loggedInWorkerCrozierRole, currentRole);
                setRoles(
                rolesResponse.filter(
                  role => Number(currentRole?.roleTier) <= Number(role.roleTier)
                ));
            } else {
              setRoles(rolesResponse || []);
            }
          } finally {
            setLoadingOptions(false);
          }
        };

        fetchRoles();
      }, [user]);

      useEffect(() => {
        console.log("IMTime Role", imtRole)
        if(imtRole?.userRole?.role !== "Support"){
          setReadOnly(false);
        }
      },[imtRole])
    
    useEffect(() => {
        if(!districtOptions.length >0){
          getLocations().then(data => {
            const { crozierEnabledList=[] } = data;
           console.log("Crozier district list", crozierEnabledList)
            setDistrictOptions([...crozierEnabledList]);
          });
        }
    }, [])

    useEffect(() => {
      if(crozierData && Object.keys(crozierData).length>0){
        setFormValues(_.cloneDeep(crozierData));
        setSelectedRole(roles.find(role => role?.id === crozierData?.role));
        setSelectedCapabilities(crozierData?.capabilities || []);
      }
    }, [crozierData, roles])
  
    useEffect(() => {
      if(formValues?.crozierDistrict?.length>0 && districtOptions.length>0){
        console.log("crozier buildings", districtOptions.length);
        const buildingOptions = [];
        districtOptions.forEach(record => {
          if(formValues?.crozierDistrict?.includes(record?.district)){
            const allBuildings = record?.buildings || {};
            console.log("crozier buildings", formValues?.crozierDistrict, allBuildings);
            Object.keys(allBuildings).forEach(building => {
              if(allBuildings[building].crozierEnabled === true
                && allBuildings[building].activityEnabled === true
              ){
                const option = {
                  buildingID: building,
                  districtID: record?.district || ""
                }
                buildingOptions.push(option);
              } 
            })
          }
        })
        setBuildingOptions(buildingOptions);
      }else{
        setBuildingOptions([]);
      }
      validForm(formValues);
    },[formValues, districtOptions])

  const handleCapabilitiesChange = (e, capability) => {
    let updatedCapabilities = [];

    if (e.target.checked) {
      updatedCapabilities = [
        ...selectedCapabilities,
        capability.id,
      ];
    } else {
      updatedCapabilities = selectedCapabilities.filter(
        (item) => item !== capability.id
      );
    }

    setSelectedCapabilities(updatedCapabilities);

    const selectedCapabilityObjects =
      selectedRole.capabilities.filter((item) =>
        updatedCapabilities.includes(item.id)
      );

    // merge screen access
    let mergedScreenAccess = selectedCapabilityObjects[0]?.screenAccess || {};

    // selectedCapabilityObjects.forEach((item) => {
    //   Object.keys(item.screenAccess || {}).forEach((key) => {
    //     const current = mergedScreenAccess[key];

    //     if (
    //       item.screenAccess[key] === "full" ||
    //       current !== "full"
    //     ) {
    //       mergedScreenAccess[key] =
    //         item.screenAccess[key];
    //     }
    //   });
    // });

    setFormValues((prev) => ({
      ...prev,
      capabilities: updatedCapabilities,
      screenAccess: mergedScreenAccess,
    }));
  }

  const validForm = (formValues) => {
    let errors = {};
    if(formValues?.isActive){
      if(!formValues?.crozierBuildings?.length > 0){
        errors['crozierBuildings'] = "Field is required";
      }
      if(!formValues?.crozierDistrict?.length > 0){
        errors['crozierDistrict'] = "Field is required";
      }
      if(!formValues?.role > 0){
        errors['role'] = "Field is required";
      }
      if(!formValues?.capabilities?.length > 0 && selectedRole?.multiCapability){
        errors['capabilities'] = "Field is required";
      }
    }
    setFormErrors(errors);
    const isValid = !Object.keys(errors).length > 0 && !_.isEqual(formValues, crozierData);
    setDisableSave(!isValid);
    return isValid;
  }

  const handleCloseSnack =  () => {
    setSnackControl(state => ({...state, open:false, message: ""}));
  }    

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const isValidForm = validForm(formValues);
      if(!isValidForm){
        throw new Error("Invalid data. Please check!")
      }
      
      const data = {
        actionTS: new Date().toISOString(),
        actionBy: user?.workerId,
        crozierDistrict: formValues?.crozierDistrict || [],
        crozierBuildings: formValues?.crozierBuildings || [],
        isActive: formValues?.isActive ? true : false,
        activityFamilyId: 'crozier',
        role: formValues?.role || "",
        capabilities: formValues?.capabilities || [],
        screenAccess: formValues?.screenAccess || {}
      }
      console.log("Crozier submit", formValues, data);
      const response = await dispatch(updateCrozierAccess(data, workerData));
      if(response && response.status){
        setSnackControl({
          open: true,
          message: "Crozier Access updated successfully.",
          severity: 'success'
        })
      }else{
        setSnackControl({
          open: true,
          message: "Crozier Access update failed.",
          severity: 'error'
        })
      }


    }catch(error){
      console.log("Crozier handleSumit error", error);
      setSnackControl({
        open: true,
        message: "Crozier Access failed to submit.",
        severity: "error"
      })
    }
  }

  return (
    <>
      <Box>
        <form action="" id="formData">
           <Snack 
              openSnack={snackControl?.open} 
              severity={snackControl?.severity} 
              message={snackControl?.message} 
              handleCloseSnack={handleCloseSnack}>
            </Snack>

          <Card sx={{ overflow: "auto", width: "100%", height:'calc(100vh - 160px)'}}>
          {(loadingRoles || loadingOptions) ? <Skeleton /> : (
            <CardContent
              style={{ marginLeft: "0%", border: "none", paddingTop: 40 }}
            >
              <Typography variant="h5" color="#616161" marginBottom={3}>
                CROZIER
              </Typography>
              <hr id="customHr2" />
              <>
                <Grid container rowSpacing={3} marginTop={2} paddingLeft={3}>
                  <Grid
                    container
                    columnSpacing={3}
                    
                    marginBottom={2}
                    alignItems="center"
                  >
                    <Grid item xs={2}  md={2} lg ={0.7}>
                      <Typography sx={{ fontSize: "18px" }}>Enable</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Switch 
                        id = "isActive"
                        name="isActive"
                        inputProps={{ 'aria-label': 'Enable Crozier Role switch' }}
                        checked={formValues?.isActive}
                        onChange={(e) => {
                          let checked = e.target.checked;
                          setFormValues({ ...formValues, isActive: checked });
                        }}
                        disabled={readOnly}
                      />
                    </Grid>
                  </Grid>
                  <Grid container columnSpacing={5} spacing={3} marginTop={3}>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                      <Autocomplete
                        renderInput={(params) => (
                          <TextField
                           {...params} 
                           label="Select District" 
                           required
                           error= {formErrors?.crozierDistrict}
                           helperText= {formErrors?.crozierDistrict}                         
                           />
                        )}
                        id="crozierDistrict"
                        name="crozierDistrict"
                        size="small"
                        options={districtOptions || []}
                        multiple
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.district || option}
                        isOptionEqualToValue={(option, value) => option === value || option.district == value}
                        value={formValues?.crozierDistrict || []}
                        onChange={(e, v) => {
                          const districtIds = v ? v.map(record => record?.district || record) :[];
                          setFormValues(prevState => ({
                            ...prevState,
                            crozierDistrict: districtIds,
                            crozierBuildings:  prevState?.crozierBuildings ? 
                            prevState?.crozierBuildings.filter(record => districtIds.includes(record?.districtID)) : []
                          }))
                        }}
                        disabled = {!formValues?.isActive || readOnly}
                        readOnly={readOnly}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                      <Autocomplete
                        renderInput={(params) => (
                          <TextField
                           {...params} 
                           label="Select Building" 
                           required
                           error= {formErrors?.crozierBuildings}
                           helperText= {formErrors?.crozierBuildings} 
                           />
                        )}
                        id="crozierBuildings"
                        name="crozierBuildings"
                        size="small"
                        disableCloseOnSelect
                        options={buildingOptions || []}
                        getOptionLabel={option => option.buildingID}
                        isOptionEqualToValue={(option, value) => value?.buildingID && value?.buildingID == option.buildingID}
                        multiple
                        value={formValues?.crozierBuildings || []}
                        onChange={(e, v) => {
                          setFormValues(prevState => ({
                            ...prevState,
                            crozierBuildings: v ? v : []
                          }))
                        }}
                        disabled = {!formValues?.isActive || readOnly}
                        readOnly={readOnly}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Autocomplete
                        renderInput={(params) => (
                          <TextField
                           {...params} 
                           label="Select Role" 
                           required
                           error= {formErrors?.role}
                           helperText= {formErrors?.role}
                           sx = {{maxWidth: '300px'}} 
                           />
                        )}
                        id="role"
                        name="role"
                        size="small"
                        options={roles || []}
                        getOptionLabel={(option) => option?.label || ""}
                        value={roles.find((role) => role.id === formValues?.role) || null}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        onChange={(e, v) => {
                          setSelectedRole(v || {});
                          setSelectedCapabilities([]);
                          setFormValues(prevState => ({
                            ...prevState,
                            role: v?.id || "",
                            capabilities: [],
                            screenAccess: v?.screenAccess || {}
                          }))
                        }}
                        disabled = {!formValues?.isActive || readOnly}
                        readOnly={readOnly || !enableRoleEdit}
                      />
                      {selectedRole?.multiCapability && (
                      <Box mt={2}>
                          <Typography variant="subtitle1" sx={{ mb: 1 }}>
                            Operations*
                          </Typography>

                          <Grid container spacing={2}>
                            {selectedRole?.capabilities?.map((capability) => (
                              <Grid item key={capability.id}>
                                <Box display="flex" alignItems="center">
                                  <Checkbox
                                    checked={selectedCapabilities.includes(capability.id)}
                                    readOnly={!enableRoleEdit}
                                    onChange={(e) => handleCapabilitiesChange(e, capability)}
                                  />

                                  <Typography>
                                    {capability.label}
                                  </Typography>
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                          {formErrors?.capabilities && (
                            <Typography
                              variant="caption"
                              color="error"
                              sx={{ ml: 1, display: "block" }}
                            >
                              {formErrors.capabilities}
                            </Typography>
                          )}
                        </Box>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
                >
                  <div>
                    <Button
                      size="medium"
                      variant="outlined"
                      onClick={(e) => handleChange(e, 0)}
                      style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{ marginRight: 30, display: readOnly ? "none" : "" }}
                      size="medium"
                      variant="contained"
                      id="svBtn"
                      disabled= {disableSave}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              </>
            </CardContent>
          )}
          </Card>
        </form>
      </Box>
    </>
  );
};

export default Crozier;
